import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import echarts from 'echarts'
import './plugins/element.js'
import '@/assets/css/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
